import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetShopifyOrderInfoSchema, ShopifyGetOrderInfoResponseData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ShopifyGetOrderInfoResponseData>>

export function useShopifySearchOrderMutation() {
  return useMutation({
    mutationFn: async (data: z.infer<typeof GetShopifyOrderInfoSchema>) => {
      return axios
        .post<Response>(`/integrations/shopify/search`, data)
        .then((response) => response.data.data)
    },
  })
}
